import { styled } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const ChangeContainer = styled.div`
    width: 20%;
    margin-right: 24px;

    @media screen and (min-width: 1440px) {
        width: 25%;
    }

    @media screen and (max-width: 1439px) {
        width: 25%;
    }

    @media screen and (min-width: 1920px) {
        width: 16%;
    }

    @media print {
        width: 30%;
    }
`;

export const TitleWrapper = styled(Flex)`
    align-items: center;
    margin-bottom: 4px;
`;

export const Title = styled.p`
    ${setFontVariant("h6", colorsPalettes.carbon[500])}
    margin: 0;
    padding-right: 8px;
`;

export const Value = styled.p`
    ${setFontVariant("h4", colorsPalettes.carbon[500])}
    margin: 0;
    padding-right: 8px;
`;

export const LoaderWrapper = styled(Flex)`
    width: 100%;
    margin-top: 4px;
`;
